import CaveFilled from '@alltrails/denali/icons/CaveFilled';
import CollNearby from '@alltrails/denali/icons/CollNearby';
import CollBeaches from '@alltrails/denali/icons/CollBeaches';
import CollHiddenGems from '@alltrails/denali/icons/CollHiddenGems';
import CollParks from '@alltrails/denali/icons/CollParks';
import CollDogFriendly from '@alltrails/denali/icons/CollDogFriendly';
import CollKidFriendly from '@alltrails/denali/icons/CollKidFriendly';
import CollLakes from '@alltrails/denali/icons/CollLakes';
import CollRivers from '@alltrails/denali/icons/CollRivers';
import CollTopPicks from '@alltrails/denali/icons/CollTopPicks';
import CollTrees from '@alltrails/denali/icons/CollTrees';
import CollViews from '@alltrails/denali/icons/CollViews';
import CollWaterfalls from '@alltrails/denali/icons/CollWaterfalls';
import CollWildflowers from '@alltrails/denali/icons/CollWildflowers';
import HistoricSiteFilled from '@alltrails/denali/icons/HistoricSiteFilled';
import HotSpringFilled from '@alltrails/denali/icons/HotSpringFilled';
import Rocky from '@alltrails/denali/icons/Rocky';
import Scramble from '@alltrails/denali/icons/Scramble';
import Sun from '@alltrails/denali/icons/Sun';
import TrailBuggy from '@alltrails/denali/icons/TrailBuggy';
import TrailStroller from '@alltrails/denali/icons/TrailStroller';
import TrailWheelchair from '@alltrails/denali/icons/TrailWheelchair';
import WildlifeFilled from '@alltrails/denali/icons/WildlifeFilled';
import type { IconComponent } from '@alltrails/denali/components/Icon';
import type { TrailHighlightType } from '@alltrails/types/TrailHighlight';

// TODO - update icons when design finalized icons for each highlight type
// https://alltrails.atlassian.net/browse/DISCO-25196
const ICONS: Record<TrailHighlightType, IconComponent> = {
  content_guide: CollParks,
  content_curated: CollHiddenGems,
  content_programmatic: CollTopPicks,
  'info_low-cell-service': CollNearby,
  review_waterfalls: CollWaterfalls,
  'review_hot-springs': HotSpringFilled,
  review_beaches: CollBeaches,
  review_caves: CaveFilled,
  'review_historic-sites': HistoricSiteFilled,
  'review_fall-foliage': CollTrees,
  review_wildflowers: CollWildflowers,
  'review_rocky-terrain': Rocky,
  review_scramble: Scramble,
  'review_overgrown-obstructed': CollTrees,
  review_buggy: TrailBuggy,
  'review_sun-exposed': Sun,
  'review_water-crossing': CollRivers,
  'review_dog-friendly': CollDogFriendly,
  'review_kid-friendly': CollKidFriendly,
  'review_stroller-friendly': TrailStroller,
  'review_wheelchair-friendly': TrailWheelchair,
  review_wildlife: WildlifeFilled,
  'review_great-views': CollViews,
  review_forests: CollTrees,
  review_lakes: CollLakes,
  review_rivers: CollRivers
};

const getTrailHighlightIcon = (type: TrailHighlightType): IconComponent => ICONS[type];

export default getTrailHighlightIcon;
